import { booleanAttribute, Component, computed, input, output } from '@angular/core';
import { NgClass } from '@angular/common';

import { SystemNotificationType } from '@app/core/system-notifications/system-notification-type.enum';
import { IconComponent, IconProperties, IconTypes } from '../icon';
import { CloseComponent } from '../close/close.component';

@Component({
    selector: 'topo-notification-banner',
    imports: [NgClass, IconComponent, CloseComponent],
    templateUrl: './notification-banner.component.html',
    styleUrl: './notification-banner.component.scss'
})
export class NotificationBannerComponent {
  type = input.required<SystemNotificationType>();
  showTypeIcon = input(false, { transform: booleanAttribute });
  borderless = input(false, { transform: booleanAttribute });
  closeable = input(false, { transform: booleanAttribute });
  onClose = output();

  private getIconPropsForType(type: SystemNotificationType): { path: string; color: string } {
    switch (type) {
      case SystemNotificationType.Success:
        return { path: 'check_circle', color: 'var(--green-600)' };
      case SystemNotificationType.Warning:
        return { path: 'error', color: 'var(--yellow-600)' };
      case SystemNotificationType.Error:
        return { path: 'cancel', color: 'var(--red-600)' };
      case SystemNotificationType.Info:
      default:
        return { path: 'info', color: 'var(--blue-600)' };
    }
  }

  protected iconProps = computed<IconProperties>(() => {
    const type = this.type();
    const { path, color } = this.getIconPropsForType(type);

    return {
      type: IconTypes.MaterialIcon,
      path,
      style: {
        fontSize: '1rem',
        color
      }
    };
  });
}
